export const MARKER_DATA_KEY = 'map';
export const HOTSPOT_GENERATED_ID = '__generated__';
export const HOTSPOT_MARKER_ID = '__marker__';

export const PIN_SHADOW_OFFSET = 2;
export const PIN_SHADOW_BLUR = 4;
export const MAP_SHADOW_BLUR = 10;
